import { useContext, useEffect, useState } from 'react';
import styles from './HisotoryOrdersPage.module.css';

import utilsOrders from '../../../../../MyConns/_Utils/utilsOrders';
import OrdersHistoryItem from './OrdersHistoryItem';
import MyDateTime from '../../../../MySections/TimeSections/MyDateTime';
import { MobiOrNotContext } from '../../../../MyContexts/MobiOrNot_Context';
import { TheMasterContext } from '../../../../MyContexts/Master_Context';

const OrdersHistoryList = (props) => {
    const [master, setMaster] = useContext(TheMasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [allMyOrders, setAllMyOrders] = useState([]);
    const [openRemarks, setOpenRemarks] = useState(null); // State to track which remarks section is open
    const [remarks, setRemarks] = useState({}); // State to track remarks input for each item
    const [orderRemarks, setOrderRemarks] = useState();
    const [thePopUp, setThePopUp] = useState();

    const [selectdedDateTime, setSelectdedDateTime] = useState();
    const [theSeleAddress, setTheSeleAddress] = useState();
    const [toShow, setToShow] = useState();
    const [loading, setLoading] = useState(true);
    const [srchOrdsmsg, setSrchOrdsmsg] = useState("מחפש הזמנות");



    const [orderTry, setOrderTry] = useState(false);

    let popsCount = 0;


    useEffect(() => {

        // המשך הלוגיקה הרגילה כאשר יש משתמש
        const getOrds = async () => {
            let allMyOrders = await utilsOrders.getOrdersHistoryList(props.clentId);
            console.log(allMyOrders);

            setAllMyOrders(allMyOrders);
            setSrchOrdsmsg(!allMyOrders || allMyOrders.length <= 0 ? "לא נמצאו הזמנות" : "")

            setLoading(false);
        };
        getOrds();
    }, []);

    const showIt = (itmId) => {
        setToShow(toShow !== itmId ? itmId : "");
    }

    return (
        <div className={`${styles.MyOrdersPage} regularPoint`}>
            <div className={styles.mainHeader}>ההזמנות שלי</div>
            {/* {!loading && */}
            <div className={styles.tableWrapper}>
                {allMyOrders.length <= 0 ?
                    <div className={"bold centerText"}>מחפש הזמנות</div>
                    :
                    <>
                        {allMyOrders?.slice().reverse().map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className="grayFrame" onClick={() => showIt(item._id)}>
                                        <div className={"bold centerText pointing"}>
                                            <div className={"bold big"}>הזמנה: {item.orderNUM}</div>
                                            <div> נוצר ב: {MyDateTime.getDate(item.dateCreated)} , מועד המסירה: {MyDateTime.getDateAndTime(item.dateToDeliver)}, סטטוס: {item.orderStatus}
                                            </div>
                                        </div>
                                        {
                                            toShow === item._id &&
                                            <OrdersHistoryItem theordr={item} />
                                        }
                                    </div>
                                </div>

                            )

                        })}
                    </>
                }
            </div>

            {/* } */}
            {thePopUp}
        </div >
    );
};

export default OrdersHistoryList;
